const getPhoneById = (phonesList, id) => {
    return phonesList.find((phone) => {
        return phone.numDispositivo === id
    });
}

module.exports = {
    getPhoneById
}
